import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useUserRole } from '@/hooks/useUserRole';

export const SuperAdminProtectedRoute: FC = () => {
  const { canAccessAdvancedData } = useUserRole();

  if (!canAccessAdvancedData) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
};
